import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const BriefcaseIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.0008 10.7201L14 13.8653C14 14.6937 13.3284 15.3653 12.5 15.3653H3.5C2.67157 15.3653 2 14.6937 2 13.8653L1.99977 10.7203C2.23746 10.7911 2.48574 10.8372 2.74165 10.8559L3 10.8653L5.99995 10.8652C6.55217 10.8651 6.99987 11.3131 7 11.8653C7 12.1108 7.17688 12.3149 7.41012 12.3572L7.5 12.3653H8.5C8.74546 12.3653 8.94961 12.1884 8.99194 11.9552L9 11.8653C8.99987 11.313 9.44761 10.8651 9.99996 10.8652L13 10.8653C13.3478 10.8653 13.6837 10.8146 14.0008 10.7201ZM9.25 1.36526C10.2165 1.36526 11 2.14876 11 3.11526V4.36526H14C14.5523 4.36526 15 4.81298 15 5.36526V7.36526C15 8.46983 14.1046 9.36526 13 9.36526H3C1.89543 9.36526 1 8.46983 1 7.36526V5.36526C1 4.81298 1.44772 4.36526 2 4.36526H5V3.11526C5 2.14876 5.7835 1.36526 6.75 1.36526H9.25ZM9.25 2.86526H6.75C6.61193 2.86526 6.5 2.97719 6.5 3.11526V4.36526H9.5V3.11526C9.5 2.97719 9.38807 2.86526 9.25 2.86526Z"
		/>
	</svg>
))
